import { Button, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { withTranslation } from "react-i18next";

const MergeConfirmModal = ({ t, show, onCloseClick, onMergeDuplicate, loading}: any) => {
    return (
        <Modal backdrop="static" isOpen={show} toggle={onCloseClick} centered={true}>
            <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                <span className='text-light'>{t("common.offcanvas.merge_records")}</span>
            </ModalHeader>
            <ModalBody className='text-center p-5'>
                <div className="mt-1">
                    <p className="text-muted fs-15">{t("common.offcanvas.are_you_sure_to_merge")}</p>
                    <p className="text-muted fs-15 mb-4">{t("common.offcanvas.merge_disclaimer1")}</p>
                    <div className="hstack gap-2 justify-content-center">
                        <Button disabled={loading} color='primary' className="btn btn-primary" onClick={() => onMergeDuplicate()}>
                            {loading ? <Spinner size="sm" type="grow" className="flex-shrink-0" role="status"> Loading... </Spinner> : null}{" "}
                            {t("common.offcanvas.merge")}
                        </Button>
                        <Button color="danger" onClick={() => onCloseClick()} outline>
                            {t("common.offcanvas.cancel")}
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    ) as unknown as JSX.Element;
};

export default withTranslation()(MergeConfirmModal);